import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import io from 'socket.io-client';
import { API_BASE, SOCKET_URL } from '../config';

delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon-2x.png',
  iconUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png',
  shadowUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png',
});

const driverIcon = new L.Icon({ iconUrl:'https://cdn-icons-png.flaticon.com/512/2972/2972185.png', iconSize:[40,40], iconAnchor:[20,40] });
const pickupIcon = new L.Icon({ iconUrl:'https://cdn-icons-png.flaticon.com/512/1483/1483336.png', iconSize:[35,35], iconAnchor:[17,35] });
const dropoffIcon = new L.Icon({ iconUrl:'https://cdn-icons-png.flaticon.com/512/484/484167.png', iconSize:[35,35], iconAnchor:[17,35] });

const STATUS_AR = { searching:'🔍 جاري البحث عن طيار...', accepted:'✅ تم قبول طلبك', picked_up:'📦 تم استلام الطرد', in_transit:'🚀 في الطريق إليك', delivered:'🎉 تم التوصيل', cancelled:'❌ ملغي', failed:'😔 فشل' };
const STATUS_COLOR = { searching:'#f59e0b', accepted:'#3b82f6', picked_up:'#8b5cf6', in_transit:'#6366f1', delivered:'#10b981', cancelled:'#ef4444', failed:'#ef4444' };

export default function TrackOrder({ order: initialOrder, token, onBack }) {
  const [order, setOrder] = useState(initialOrder);
  const [driver, setDriver] = useState(null);
  const [driverPos, setDriverPos] = useState(null);
  const [rating, setRating] = useState(0);
  const [review, setReview] = useState('');
  const [rated, setRated] = useState(false);
  const [ratingLoading, setRatingLoading] = useState(false);

  useEffect(() => {
    axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    const interval = setInterval(() => {
      axios.get(`${API_BASE}/orders/${order.id}`).then(r => {
        setOrder(r.data.order);
        if (r.data.order.driver_name) setDriver(r.data.order);
      }).catch(()=>{});
    }, 5000);
    // Initial load
    axios.get(`${API_BASE}/orders/${order.id}`).then(r => {
      setOrder(r.data.order);
      if (r.data.order.driver_name) setDriver(r.data.order);
    }).catch(()=>{});
    return () => clearInterval(interval);
  }, [order.id, token]);

  useEffect(() => {
    const socket = io(SOCKET_URL, { auth: { token } });
    socket.on('driver:location', (data) => {
      if (data.orderId === order.id) setDriverPos({ lat: data.lat, lng: data.lng });
    });
    return () => socket.disconnect();
  }, [order.id, token]);

  const submitRating = async () => {
    if (!rating) return;
    setRatingLoading(true);
    try {
      await axios.post(`${API_BASE}/orders/${order.id}/rate`, { rating, review });
      setRated(true);
    } catch(e) { console.error(e); }
    setRatingLoading(false);
  };

  if (order?.status === 'delivered' && !rated) return (
    <div style={{direction:'rtl',minHeight:'100vh',background:'linear-gradient(135deg,#10b981,#059669)',display:'flex',alignItems:'center',justifyContent:'center',padding:'20px'}}>
      <div style={{background:'#fff',borderRadius:'24px',padding:'32px',maxWidth:'380px',width:'100%',textAlign:'center',boxShadow:'0 20px 60px rgba(0,0,0,0.2)'}}>
        <div style={{fontSize:'64px',marginBottom:'8px'}}>🎉</div>
        <h2 style={{margin:'0 0 4px',color:'#1a1a2e',fontSize:'24px',fontWeight:'900'}}>تم التوصيل!</h2>
        <p style={{margin:'0 0 24px',color:'#888',fontSize:'14px'}}>كيف كانت تجربتك مع الطيار؟</p>
        <div style={{display:'flex',justifyContent:'center',gap:'8px',marginBottom:'20px'}}>
          {[1,2,3,4,5].map(s => (
            <button key={s} onClick={()=>setRating(s)} style={{fontSize:'36px',background:'none',border:'none',cursor:'pointer',transform:rating>=s?'scale(1.2)':'scale(1)',filter:rating>=s?'none':'grayscale(1)'}}>⭐</button>
          ))}
        </div>
        <div style={{marginBottom:'16px',display:'flex',flexWrap:'wrap',gap:'8px',justifyContent:'center'}}>
          {[['ممتاز! طيار محترف','😍'],['سريع ومنضبط','👍'],['تأخر قليلاً','⏰'],['خدمة عادية','😐']].map(([t,e])=>(
            <button key={t} onClick={()=>setReview(t)} style={{padding:'8px 14px',borderRadius:'20px',border:'2px solid',borderColor:review===t?'#10b981':'#eee',background:review===t?'#f0f0ff':'#fff',cursor:'pointer',fontSize:'13px',color:review===t?'#10b981':'#555'}}>
              {e} {t}
            </button>
          ))}
        </div>
        <textarea value={review} onChange={e=>setReview(e.target.value)} placeholder="أضف تعليقك (اختياري)..." style={{width:'100%',padding:'12px',border:'1px solid #ddd',borderRadius:'12px',fontSize:'14px',boxSizing:'border-box',resize:'none',height:'80px',marginBottom:'16px',direction:'rtl'}}/>
        <button onClick={submitRating} disabled={!rating||ratingLoading} style={{width:'100%',padding:'16px',background:!rating?'#ccc':'linear-gradient(135deg,#10b981,#059669)',color:'#fff',border:'none',borderRadius:'14px',fontSize:'16px',fontWeight:'bold',cursor:!rating?'not-allowed':'pointer',marginBottom:'10px'}}>
          {ratingLoading?'⏳ جاري الإرسال...':'⭐ إرسال التقييم'}
        </button>
        <button onClick={()=>setRated(true)} style={{width:'100%',padding:'12px',background:'none',border:'none',color:'#aaa',fontSize:'14px',cursor:'pointer'}}>تخطي</button>
      </div>
    </div>
  );

  if (order?.status === 'delivered' && rated) return (
    <div style={{direction:'rtl',minHeight:'100vh',background:'linear-gradient(135deg,#27ae60,#2ecc71)',display:'flex',alignItems:'center',justifyContent:'center',padding:'20px'}}>
      <div style={{background:'#fff',borderRadius:'24px',padding:'32px',maxWidth:'380px',width:'100%',textAlign:'center'}}>
        <div style={{fontSize:'80px',marginBottom:'16px'}}>✅</div>
        <h2 style={{margin:'0 0 8px',color:'#1a1a2e',fontSize:'24px'}}>شكراً لتقييمك!</h2>
        <p style={{margin:'0 0 24px',color:'#888'}}>رأيك يساعدنا على تحسين الخدمة</p>
        <button onClick={onBack} style={{width:'100%',padding:'16px',background:'linear-gradient(135deg,#10b981,#059669)',color:'#fff',border:'none',borderRadius:'14px',fontSize:'16px',fontWeight:'bold',cursor:'pointer'}}>🏠 العودة للرئيسية</button>
      </div>
    </div>
  );

  const center = driverPos || (order.pickup_lat ? { lat: parseFloat(order.pickup_lat), lng: parseFloat(order.pickup_lng) } : { lat: 30.0444, lng: 31.2357 });

  return (
    <div style={{direction:'rtl',minHeight:'100vh',background:'#f5f6fa'}}>
      <div style={{background:'linear-gradient(135deg,#10b981,#059669)',padding:'20px',color:'#fff'}}>
        <button onClick={onBack} style={{background:'rgba(255,255,255,0.2)',border:'none',color:'#fff',padding:'8px 16px',borderRadius:'20px',cursor:'pointer',marginBottom:'12px',fontSize:'13px'}}>← رجوع</button>
        <div style={{textAlign:'center'}}>
          <p style={{margin:'0 0 8px',fontSize:'14px',opacity:0.8}}>حالة الطلب</p>
          <p style={{margin:'0 0 4px',fontSize:'22px',fontWeight:'bold'}}>{STATUS_AR[order.status]||order.status}</p>
          <div style={{width:'120px',height:'4px',background:'rgba(255,255,255,0.3)',borderRadius:'2px',margin:'12px auto 0'}}>
            <div style={{width:order.status==='searching'?'20%':order.status==='accepted'?'40%':order.status==='picked_up'?'60%':order.status==='in_transit'?'80%':'100%',height:'100%',background:'#fff',borderRadius:'2px',transition:'width 0.5s'}}/>
          </div>
        </div>
      </div>

      <div style={{margin:'16px',borderRadius:'16px',overflow:'hidden',boxShadow:'0 4px 20px rgba(0,0,0,0.1)',height:'280px'}}>
        <MapContainer center={[center.lat, center.lng]} zoom={14} style={{height:'100%',width:'100%'}}>
          <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"/>
          {driverPos && <Marker position={[driverPos.lat,driverPos.lng]} icon={driverIcon}><Popup>🛵 الطيار</Popup></Marker>}
          {order.pickup_lat && <Marker position={[parseFloat(order.pickup_lat),parseFloat(order.pickup_lng)]} icon={pickupIcon}><Popup>📍 نقطة الاستلام</Popup></Marker>}
          {order.dropoff_lat && <Marker position={[parseFloat(order.dropoff_lat),parseFloat(order.dropoff_lng)]} icon={dropoffIcon}><Popup>🏁 نقطة التسليم</Popup></Marker>}
        </MapContainer>
      </div>

      {driver && (
        <div style={{margin:'0 16px 16px',background:'#fff',borderRadius:'16px',padding:'16px',boxShadow:'0 2px 10px rgba(0,0,0,0.06)',display:'flex',alignItems:'center',gap:'12px'}}>
          <div style={{width:'50px',height:'50px',borderRadius:'50%',background:'linear-gradient(135deg,#10b981,#059669)',display:'flex',alignItems:'center',justifyContent:'center',fontSize:'24px',flexShrink:0}}>🛵</div>
          <div style={{flex:1}}>
            <p style={{margin:'0 0 2px',fontWeight:'bold',color:'#1a1a2e',fontSize:'15px'}}>{driver.driver_name}</p>
            <p style={{margin:'0 0 2px',color:'#888',fontSize:'13px'}}>{driver.vehicle_type||''} {driver.vehicle_plate||''}</p>
            <p style={{margin:0,color:'#f59e0b',fontSize:'13px'}}>⭐ {driver.avg_rating||'جديد'}</p>
          </div>
        </div>
      )}
      <div style={{margin:'0 16px',background:'#fff',borderRadius:'16px',padding:'20px',boxShadow:'0 2px 10px rgba(0,0,0,0.06)'}}>
        <div style={{display:'flex',justifyContent:'space-between',padding:'10px 0',borderBottom:'1px solid #f0f0f0'}}>
          <span style={{color:'#666',fontSize:'14px'}}>📍 من</span>
          <span style={{color:'#333',fontSize:'14px',fontWeight:'bold',maxWidth:'200px',textAlign:'left'}}>{order.pickup_address?.substring(0,40)}...</span>
        </div>
        <div style={{display:'flex',justifyContent:'space-between',padding:'10px 0',borderBottom:'1px solid #f0f0f0'}}>
          <span style={{color:'#666',fontSize:'14px'}}>🏁 إلى</span>
          <span style={{color:'#333',fontSize:'14px',fontWeight:'bold',maxWidth:'200px',textAlign:'left'}}>{order.dropoff_address?.substring(0,40)}...</span>
        </div>
        <div style={{display:'flex',justifyContent:'space-between',padding:'10px 0'}}>
          <span style={{color:'#666',fontSize:'14px'}}>💰 السعر</span>
          <span style={{color:'#10b981',fontSize:'16px',fontWeight:'bold'}}>{order.base_price} جنيه</span>
        </div>
      </div>
    </div>
  );
}
